import React from 'react';

const FeaturedCircleSVG = () => (
    <svg
        viewBox="0 0 126.34 124.89"
    >
        <defs>
            <clipPath id="featured_fixed_svg__clip-path">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M32.28 7.9l7.89-3.74 1.27 2.64-4.55 2.16.99 2.06 4.52-2.14 1.23 2.54-4.52 2.14 2.26 4.71-3.34 1.58L32.28 7.9z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-2">
                <rect className="featured_fixed_svg__cls-2" x={-32} y={-208.69} />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-3">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M58.42 0L48.23 1.62l2.12 13.08 10.19-1.63-.46-2.81-6.53 1.04-.39-2.43 6.47-1.03-.43-2.7-6.48 1.03-.37-2.32 6.53-1.04L58.42 0z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-5">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M75.6 12.14L69.39 11 68 13.35l-3.87-.7L71.79.58l5.21.94 3 13.98-3.85-.69zm-.52-2.81L74 3.54l-3.07 5z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-7">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M89.21 8.85l-3.07-1.58 1.37-2.61 9.42 4.87-1.37 2.61-3.07-1.59-4.79 9.13-3.29-1.69 4.8-9.14z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-9">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M95.83 23.79a5.55 5.55 0 0 1 2-4.19l5.65-5.51 2.6 2.62-5.48 5.34a3.11 3.11 0 0 0-1.11 2.06 2.93 2.93 0 0 0 1 2.05 3 3 0 0 0 2.06 1.07 3.13 3.13 0 0 0 2.09-1.08l5.47-5.33 2.6 2.62-5.63 5.56a5.63 5.63 0 0 1-4.25 1.91 7.31 7.31 0 0 1-4.52-2.53q-2.37-2.4-2.48-4.54"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-11">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M112.18 38.51L112 38l-4.55 2.07-1.55-3.34 12.1-5.5 2.89 6.27a6.3 6.3 0 0 1 .68 2.83 3.38 3.38 0 0 1-.85 2.2 4.72 4.72 0 0 1-1.58 1.12 4.84 4.84 0 0 1-2 .48 3.61 3.61 0 0 1-3.14-1.88l-2.77 6.12-1.85-4zm1.89-1.45l.92 2a3.74 3.74 0 0 0 .72 1.1 1.25 1.25 0 0 0 .89.37 1.91 1.91 0 0 0 .82-.2 2 2 0 0 0 .65-.44 1.28 1.28 0 0 0 .3-1 3.49 3.49 0 0 0-.36-1.25l-.92-2z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-13">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M125.18 50.6l1.16 10.18-2.86.32-.74-6.52-2.35.26.74 6.47-2.74.31-.74-6.47-2.46.27.75 6.53-2.86.32-1.16-10.18 13.26-1.49z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-15">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M126.06 70l-1.49 6.5a9 9 0 0 1-1.82 3.9 5.32 5.32 0 0 1-3.12 1.81 7.72 7.72 0 0 1-3.19-.11 7.5 7.5 0 0 1-3-1.28 5.36 5.36 0 0 1-2-3 8.91 8.91 0 0 1 .08-4.28l1.49-6.49zm-11.44 3.82a4.8 4.8 0 0 0-.07 2.21 2.72 2.72 0 0 0 1 1.48 5.82 5.82 0 0 0 3.75.83 2.58 2.58 0 0 0 1.51-.91 4.7 4.7 0 0 0 .9-2l.58-2.5-7.08-1.6z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-17">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M105.86 94.87a2.66 2.66 0 0 1 1.53-.15 3.2 3.2 0 0 1 1.47.69 3.32 3.32 0 0 1 1 1.28 2.58 2.58 0 0 1 .14 1.48 3.28 3.28 0 0 1-.72 1.46 3.21 3.21 0 0 1-1.27 1 2.59 2.59 0 0 1-1.48.16 3.47 3.47 0 0 1-2.47-2 2.76 2.76 0 0 1-.17-1.5 3.08 3.08 0 0 1 .68-1.44 3.15 3.15 0 0 1 1.29-1"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-19">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M96.12 115.99l-7.74 4.05-1.38-2.59 4.47-2.34-1.07-2.02-4.44 2.31-1.32-2.48 4.44-2.32-2.45-4.61 3.28-1.72 6.21 11.72z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-21">
                <path
                    className="featured_fixed_svg__cls-2"
                    d="M67.69 109.9h12.74v14.99H67.69z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-23">
                <path className="featured_fixed_svg__cls-2" d="M66 109.31h16v16H66z" />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-24">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M80.43 122.88l-10.12 2.01-.57-2.8 6.49-1.28-.46-2.3-6.44 1.27-.54-2.68 6.43-1.28-.48-2.41-6.49 1.29-.56-2.79 10.12-2.01 2.62 12.98z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-26">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M52.66 113.41l6.25.87 1.33-2.37 3.89.55-7.22 12.36-5.26-.74-3.48-13.86 3.87.54zm.63 2.8l1.32 5.73 2.87-5.15z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-28">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M39.2 117.22l3.13 1.47-1.27 2.66-9.6-4.5 1.27-2.66 3.12 1.46 4.44-9.31 3.34 1.57-4.43 9.31z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-30">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M32 102.56a5.48 5.48 0 0 1-1.82 4.26l-5.43 5.72-2.7-2.54 5.26-5.54a3.12 3.12 0 0 0 1-2.11 2.87 2.87 0 0 0-1.11-2 3 3 0 0 0-2.1-1 3.12 3.12 0 0 0-2.05 1.15l-5.26 5.54-2.7-2.52 5.43-5.72a5.59 5.59 0 0 1 4.18-2.07c1.43 0 3 .82 4.62 2.35s2.52 3 2.64 4.45"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-32">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M15.09 88.48l.25.48 4.47-2.24L21.48 90l-11.9 6-3.14-6.18A6.39 6.39 0 0 1 5.65 87a3.44 3.44 0 0 1 .76-2.23A4.81 4.81 0 0 1 8 83.61a4.74 4.74 0 0 1 2-.55 3.59 3.59 0 0 1 3.24 1.75l2.52-6.23 2 3.94zM13.27 90l-1-2a3.47 3.47 0 0 0-.77-1 1.22 1.22 0 0 0-.9-.34 1.82 1.82 0 0 0-.81.24 1.74 1.74 0 0 0-.63.46 1.25 1.25 0 0 0-.27 1 3.7 3.7 0 0 0 .41 1.25l1 1.95z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-34">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M1.63 76.9L.08 66.78l2.84-.43 1 6.49 2.33-.36-.99-6.43 2.73-.41.99 6.43 2.45-.37-1-6.49 2.84-.43 1.55 10.13L1.63 76.9z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-36">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M0 57.53L1.24 51a9.08 9.08 0 0 1 1.66-4A5.32 5.32 0 0 1 6 45.09a7.64 7.64 0 0 1 3.2 0 7.49 7.49 0 0 1 3 1.17 5.27 5.27 0 0 1 2.12 2.9 9 9 0 0 1 .09 4.28L13.11 60zm11.29-4.25a4.77 4.77 0 0 0 0-2.21 2.64 2.64 0 0 0-1-1.44A4.63 4.63 0 0 0 8.41 49a4.82 4.82 0 0 0-2 0 2.71 2.71 0 0 0-1.48 1 4.81 4.81 0 0 0-.82 2l-.48 2.53 7.14 1.33z"
                />
            </clipPath>
            <clipPath id="featured_fixed_svg__clip-path-38">
                <path
                    className="featured_fixed_svg__cls-1"
                    d="M19.21 31.91a2.83 2.83 0 0 1-1.52.21 3.11 3.11 0 0 1-1.5-.64 3.22 3.22 0 0 1-1.05-1.24 2.65 2.65 0 0 1-.2-1.47 3.26 3.26 0 0 1 .67-1.49 3.15 3.15 0 0 1 1.23-1 2.68 2.68 0 0 1 1.48-.28 3.32 3.32 0 0 1 1.49.65 3.16 3.16 0 0 1 1 1.25 2.68 2.68 0 0 1 .23 1.5 3 3 0 0 1-.62 1.46 3.11 3.11 0 0 1-1.25 1"
                />
            </clipPath>
        </defs>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M22.28-5.84h31.35v35.69H22.28z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-3)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M38.23-10h32.3v34.7h-32.3z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-5)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M54.1-9.42h35.86V25.5H54.1z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-7)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M74.41-5.34h32.52v35.03H74.41z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-9)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M85.83 4.09h36.9v36.78h-36.9z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-11)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M95.85 21.23h35.7v37.15h-35.7z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-13)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M101.92 40.6h34.42v31.67h-34.42z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-15)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M101.26 57.05h34.8v35.27h-34.8z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-17)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M93.85 84.67h26.2v26.14h-26.2z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-19)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M74.64 94.27h31.48v35.76H74.64z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-21)"
        >
            <g className="featured_fixed_svg__cls-17">
                <g
                    className="featured_fixed_svg__cls-17"
                    clipPath="url(#featured_fixed_svg__clip-path-24)"
                >
                    <path
                        className="featured_fixed_svg__cls-5"
                        d="M57.69 99.9h32.74v34.99H57.69z"
                    />
                </g>
            </g>
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-26)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M38.17 100.22h35.96v34.6H38.17z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-28)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M21.46 96.34h32.18v35.01H21.46z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-30)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M5.13 85.75h36.89v36.79H5.13z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-32)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M-4.35 68.58h35.83v37.39H-4.35z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-34)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M-9.92 54.78h34.75V86.9H-9.92z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-36)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M-10 34.92h34.56v35.06H-10z"
            />
        </g>
        <g
            className="featured_fixed_svg__cls-4"
            clipPath="url(#featured_fixed_svg__clip-path-38)"
        >
            <path
                className="featured_fixed_svg__cls-5"
                d="M4.91 16.01H31.1v26.14H4.91z"
            />
        </g>
    </svg>
);

export default FeaturedCircleSVG;
